import {cssVar} from "../../components/cssInJs";
function cssPin(options,obj) {
  var color = options.color || 'blue';
  var size = options.size || 26;
  var squareDiagonal = Math.sqrt(Math.pow(size, 2) * 2);
  var radius = size / 2;
  var height = radius + (squareDiagonal / 2);
  return new L.DivIcon({
    className: 'simpleMarkerIcon',
    iconAnchor: new L.Point(radius, height), //length of square diagonal. pythagorean
    iconSize: new L.Point(radius * 2, height),
    popupAnchor: new L.Point(0, height * -0.8), // 0.8 instead of 1 because a little overlap is nice
    html: `
            <div class="simpleMarkerIconPin position-relative text-center font-weight-bold" style="
    
              background-color: ${color};
              width: ${size}px;
              height: ${size}px;
              border-radius: 50% 50% 50% 0;
              box-shadow: 1px 2px 8px rgba(0,0,0,0.25);
              transform: rotate(-45deg);
              "><i class="simpleMarkerIconPinCenter text-white fas fa-circle fa-lg" 
                   style="
                        line-height: ${size}px;
                        text-shadow:0 0 2px rgba(0,0,0,0.25)"></i>
              </div>
              <div class="simpleMarkerIconPinShadow" style="
                width: ${size/2}px;
                height: ${size/8}px;
                z-index: -5;
                box-shadow: 0 0 ${size/8}px rgba(0,0,0,0.30);
                border-radius: 50%;
                background-color:rgba(0,0,0,0.20);
                margin-left: ${(size/2)}px;
                margin-top: ${size/16}px;
              "></div>
`
  })
}


angular.module('clientDashboardApp').directive('overviewMap',
    function () {
    // Global colors
    const red = cssVar("--danger");
    const yellow = cssVar("--warning");
    const green = cssVar("--success");
    const mapHeight = document.getElementById("performanceSummaryMapWrapper")?.offsetHeight;
      return {
            restrict: 'E',
            replace: true,
            template: `<div style="min-width: 310px; height: ${mapHeight || 600}px; margin: 0 auto;display: flex;align-items: center;"></div>`,
            scope: {
                centerPoint: '=',
                locations: '=',
                avgReviews: '=',
                reviewSummaryByLocation: '=',
                brandConfig: '='

            },
            link: function (scope, element, attrs) {
                const GOOD_AVG_RATING = Number.parseFloat(scope.brandConfig.mapRange.averageMax + 0.1).toFixed(1)
                const OK_AVG_MAX = scope.brandConfig.mapRange.averageMax
                const OK_AVG_RATING = scope.brandConfig.mapRange.averageMin

                var map = false;

                var initMap = function () {
                    if (map) map.remove();

                    L.Icon.Default.imagePath = 'images/leaflet';

                    var latlng = L.latLng(39.828127, -98.579404);
                    var defaultZoom = 5;

                    var stateReviewSummary = scope.avgReviews;

                    var info = L.control();

                    var tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: ''
                    });

                    map = L.map(element[0], {center: latlng, zoom: defaultZoom, maxZoom: 18, layers: [tiles]});
                    window.summaryMap = map
                    function roundRating(num) {
                        num = Math.round(num * 10) / 10;
                        return num;
                    }

                    function clusterStyle(cluster) {
                        var locationsInCluster = cluster.getChildCount();
                        var markers = cluster.getAllChildMarkers();
                        var n = 0.0;
                        for (var i = 0; i < markers.length; i++) {
                            var avgReviewForLocation = scope.reviewSummaryByLocation[markers[i].locationId].avgReview;
                            if (angular.isDefined(avgReviewForLocation)) {
                                n += avgReviewForLocation;
                            }
                        }

                        var c = ' map-region-summary-';
                        if (locationsInCluster > 0) {
                            var avgReviewForRegion = roundRating(n / locationsInCluster);

                            if (avgReviewForRegion >= GOOD_AVG_RATING) {
                                c += 'good';
                            } else if (avgReviewForRegion >= OK_AVG_RATING) {
                                c += 'average';
                            } else if (avgReviewForRegion >= 0) {
                                c += 'poor';
                            }
                        } else {
                            c += 'none';
                        }

                        return new L.DivIcon({
                          html: '<div><span>' + locationsInCluster + '</span></div>',
                          className: 'map-region-summary' + c,
                          iconSize: new L.Point(40, 40) });
                    }

                    var allLocations = new L.FeatureGroup();
                    var markerClusters = {};
                    angular.forEach(scope.locations, function (addressPoint) {
                        var a = addressPoint;
                        var title = a.message;
                        var avgReviewForLocation = scope.reviewSummaryByLocation[addressPoint.locationId].avgReview;

                        var markerColor = red;
                        if (angular.isDefined(avgReviewForLocation)) {
                            avgReviewForLocation= roundRating(avgReviewForLocation);

                            if (avgReviewForLocation >= GOOD_AVG_RATING) {
                                markerColor = green;
                            } else if (avgReviewForLocation >= OK_AVG_RATING) {
                                markerColor = yellow;
                            } else if (avgReviewForLocation >= 0) {
                                markerColor = red;
                            }
                        }

                      var marker = L.marker(L.latLng(a.lat, a.lng), { icon: cssPin({color: markerColor}) });
                        marker.locationId = addressPoint.locationId;
                        marker.bindPopup(title);

                        if (!markerClusters[addressPoint.state]) {
                            let maxClusterRadius = (zoom) => {
                              let zoomScale = 5 / (zoom + 1)
                              return 60 * zoomScale
                            }
                            markerClusters[addressPoint.state] = L.markerClusterGroup({ maxClusterRadius: maxClusterRadius, spiderfyOnMaxZoom: true, chunkedLoading: false, showCoverageOnHover: false, iconCreateFunction: clusterStyle, animate: true});
                        }
                        markerClusters[addressPoint.state].addLayer(marker);
                        marker.addTo(allLocations);
                    });

                    var getColor = function (d) {
                        d = roundRating(d);
                        return d >= GOOD_AVG_RATING ? green :
                            d >= OK_AVG_RATING ? yellow :
                            red;
                    };

                    function style(feature) {
                        var avgRating;
                        var baseStyle = {
                            fillColor: '#FFFFFF',
                            weight: 1,
                            opacity: 1,
                            color: 'white',
                            fillOpacity: 0.4
                        };
                        if (stateReviewSummary[feature.properties.iso_3166_2]) {
                            avgRating = stateReviewSummary[feature.properties.iso_3166_2].avgRating;
                            baseStyle.fillColor = getColor(avgRating);
                            baseStyle.fillOpacity = 0.7;
                        }
                        return baseStyle;
                    }

                    var geojson;
                    var currentLayer;
                    var previousStateGeoJson;
                    var previousStateSummary;

                    function highlightFeature(e) {
                        var layer = e.target;
                        previousStateGeoJson = layer;
                        layer.setStyle({
                            weight: 3,
                            color: '#666',
                            dashArray: '',
                            fillOpacity: 0.7
                        });

                        if (!L.Browser.ie && !L.Browser.opera) {
                            layer.bringToFront();
                        }
                        info.update(layer.feature.properties);
                    }

                    function resetHighlight(e) {
                        if (previousStateGeoJson) {
                            geojson.resetStyle(previousStateGeoJson);
                        }
                        info.update();
                    }

                    function zoomToFeature(e) {
                        currentLayer = markerClusters[e.target.feature.properties.name];
                        if(currentLayer && currentLayer == previousStateSummary){
                            return;
                        }
                        resetHighlight(e);
                        highlightFeature(e);
                        map.fitBounds(e.target.getBounds());
                        if (currentLayer) {
                            map.removeLayer(currentLayer);
                        }

                        if (previousStateSummary) {
                            map.addLayer(previousStateSummary);
                        }

                        map.addLayer(currentLayer);
                        previousStateSummary = stateSummaryLayers[e.target.feature.properties.name];
                        if(map.hasLayer(previousStateSummary)) {
                            map.removeLayer(previousStateSummary);
                        }
                    }

                    function zoomMap(e) {
                        currentLayer = markerClusters[e.target.feature.properties.name];
                        if(!currentLayer || currentLayer != previousStateSummary){
                            zoomToFeature(e);
                            return;
                        }
                        // Zoom exactly to each double-clicked point
                        map.setView(e.latlng, map.getZoom() + 1);
                    }

                    var stateSummaryLayers = {};
                    function onEachFeature(feature, layer) {
                        layer.on({
                            mouseover: highlightFeature,
                            mouseout: resetHighlight,
                            click: zoomToFeature,
                            dblclick: zoomMap
                        });
                    }

                    var statesData = require('../data/map-regions.json');
                    geojson = L.geoJson(statesData, {style: style, onEachFeature: onEachFeature}).addTo(map);

                    info.onAdd = function (map) {
                        this.infoDiv = L.DomUtil.create('div', 'info'); // create a div with a class "info"
                        this.update();
                        return this.infoDiv;
                    };

                    // method that we will use to update the control based on feature properties passed
                    info.update = function (props) {
                        var reviewText;
                        if (!props) {
                            reviewText = 'Hover over a region with locations';
                        } else if (stateReviewSummary[props.iso_3166_2]) {
                            reviewText = '<b>' + props.name + '</b><br />Review Average: ' + roundRating(stateReviewSummary[props.iso_3166_2].avgRating) + ' / 5';
                        } else {
                            reviewText = '<b>' + props.name + '</b><br />No locations in this region.';
                        }
                        this.infoDiv.innerHTML = '<h4>Performance Summary</h4>' + reviewText;
                    };

                    info.addTo(map);
                    _.each(markerClusters, function (cluster) {
                        map.addLayer(cluster);
                    });

                    var zoomReset = L.control({position: 'topleft'});

                    zoomReset.onAdd = function (map) {
                        this.zoomResetDiv = L.DomUtil.create('div', 'map-reset-zoom'); // create a div with a class "info"
                        this.zoomResetDiv.innerHTML = '<strong>Reset</strong>';
                        L.DomEvent
                            .addListener(this.zoomResetDiv, 'click', L.DomEvent.stop)
                            .addListener(this.zoomResetDiv, 'click', this.reset, this);
                        L.DomEvent.disableClickPropagation(this.zoomResetDiv);

                        return this.zoomResetDiv;
                    };

                    zoomReset.reset = function () {
                        if (allLocations.getLayers().length > 0) {
                            map.fitBounds(allLocations.getBounds(), {maxZoom: 7})
                        } else {
                            map.setView(latlng, defaultZoom);
                        }
                    };

                    zoomReset.addTo(map);

                    function removeHighlightMap(e) {
                        if (e.target.getZoom() >= 8) {
                            if (map.hasLayer(geojson)) {
                                map.removeLayer(geojson);
                            }
                        } else if (!map.hasLayer(geojson)) {
                            map.addLayer(geojson);
                        }
                    }

                    function zoomEnd(e){
                        removeHighlightMap(e);
                    }

                    map.on({zoomend: zoomEnd});

                    //Map legend
                    var legend = L.control({position: 'bottomright'});

                    legend.onAdd = function (map) {

                        var div = L.DomUtil.create('div', 'info legend');
                        div.innerHTML = '<h5>Average Review Rating</h5>';
                        div.innerHTML +=
                            `<div style="clear:both"><i style="background:${getColor(GOOD_AVG_RATING)}"></i>Excellent ${GOOD_AVG_RATING} or higher</div>`;
                        div.innerHTML +=
                            `<div style="clear:both"><i style="background:${getColor(OK_AVG_RATING)}"></i>Average between ${OK_AVG_RATING} and ${OK_AVG_MAX}</div>`;
                        div.innerHTML +=
                            `<div style="clear:both"><i style="background:${getColor(0)}"></i>Poor under ${OK_AVG_RATING} or no reviews</div>`;

                        return div;
                    };

                    //Set initial zoom level
                    zoomReset.reset();
                    legend.addTo(map);
                };

                scope.$watch('locations', function (newValue, oldValue) {
                    initMap();
                });
            }//end watch
        }
    });
